import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import FirebaseActions from '~redux/Auth/actions';
import LocalStorage from '~services/LocalStorageService';
import LoadingWrapper from '~components/Spinner/LoadingWrapper';
import CoreActions from '~redux/Core/actions';
import { startIntercom } from '~services/IntercomService';
import intercomScript from '~scripts/intercom';

import OrientationOverlay from '../OrientationOverlay';

function CoreSettingsWrapper({ children }) {
  const dispatch = useDispatch();
  const tokenManager = LocalStorage.getTokenManager();
  useEffect(() => {
    dispatch(
      CoreActions.getTenant(() => {
        intercomScript(startIntercom);
        if (tokenManager) {
          dispatch(FirebaseActions.refreshFirebaseToken(tokenManager.refreshToken));
        }
      })
    );
    dispatch(CoreActions.getLocalStorageData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const { settingsLoading, settings } = useSelector((state) => state.core);

  return (
    <LoadingWrapper loading={settingsLoading || !settings}>
      {children}
      <OrientationOverlay />
    </LoadingWrapper>
  );
}

export default CoreSettingsWrapper;
